export default __webpack_public_path__ + "static/sway-1-0a99f81dc0c298fa937594a0e5cfbfec.jpg";